import { render, staticRenderFns } from "./thesisGroupList.vue?vue&type=template&id=45e16cc7&scoped=true&"
import script from "./thesisGroupList.vue?vue&type=script&lang=js&"
export * from "./thesisGroupList.vue?vue&type=script&lang=js&"
import style0 from "./thesisGroupList.vue?vue&type=style&index=0&id=45e16cc7&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e16cc7",
  null
  
)

export default component.exports